import React from 'react';
import { motion } from 'framer-motion';
import { Dumbbell, Trophy, Flag, Medal } from 'lucide-react';
export function Goals() {
  const goals = [{
    title: 'Train With Discipline',
    icon: <Dumbbell size={32} data-id="element-48" />,
    desc: 'Daily commitment to physical conditioning, technical mastery, and mental toughness.'
  }, {
    title: 'Compete Nationally',
    icon: <Trophy size={32} data-id="element-49" />,
    desc: 'Traveling to major tournaments to test skills against the best athletes in the country.'
  }, {
    title: 'Represent Team USA',
    icon: <Flag size={32} data-id="element-50" />,
    desc: 'Earning a spot on the national team to represent the United States internationally.'
  }, {
    title: 'Pursue the Olympic Dream',
    icon: <Medal size={32} data-id="element-51" />,
    desc: 'The ultimate goal: stepping onto the Olympic mat and competing for gold.'
  }];
  return <section id="goals" className="py-20 lg:py-28 bg-usa-navy text-white relative overflow-hidden" data-id="element-52">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-usa-blue/20 -skew-x-12 translate-x-32" data-id="element-53" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-54">
        <div className="text-center mb-16" data-id="element-55">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-display font-bold mb-6" data-id="element-56">
            CYRUS' PATH FORWARD
          </motion.h2>
          <div className="w-16 h-1 bg-usa-red mx-auto" data-id="element-57" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-58">
          {goals.map((goal, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-8 hover:bg-white/10 transition-colors group" data-id="element-59">
              <div className="text-usa-gold mb-6 group-hover:scale-110 transition-transform origin-left" data-id="element-60">
                {goal.icon}
              </div>
              <h3 className="text-2xl font-display font-bold mb-4 tracking-wide" data-id="element-61">
                {goal.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-62">{goal.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}